import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    bulkTransfers: {
      featurePreview: {
        subtitle:
          'Save time with your transfers: group them all together in one file and make the processing of your payments or wages easier.',
        title: 'Send up to 100 transfers at once in just a few clicks',
      },
      upgradeIncentive: {
        subtitlePlural:
          'Select Shine {firstPlansNames} or {lastPlanName} to enable this feature now.',
        subtitleSingular: 'Select Shine {planName} to enable this feature now.',
        title: 'Bulk transfers are available starting from Shine {planName}',
      },
    },
    callToActionLabel: 'Switch to another plan',
  },
  fr: {
    bulkTransfers: {
      featurePreview: {
        subtitle:
          'Gagnez du temps sur vos virements\xA0: regroupez-les tous sur un seul fichier et facilitez le traitement de vos paiements ou de vos salaires.',
        title: 'Envoyez jusqu’à 100 virements en quelques clics',
      },
      upgradeIncentive: {
        subtitlePlural:
          'Choisissez les abonnements Shine {firstPlansNames} ou {lastPlanName} pour activer cette fonctionnalité dès aujourd’hui.',
        subtitleSingular:
          'Choisissez l’abonnement Shine {planName} pour activer cette fonctionnalité dès aujourd’hui.',
        title:
          'Les virements groupés sont disponibles à partir de l’abonnement Shine {planName}',
      },
    },
    callToActionLabel: 'Changer d’abonnement',
  },
} as const);

export default locales;
